/** Nazivi tipova razloga odbijanja (čl. 52) — isti kodovi kao u modalu za odbijanje. */
export const REJECTION_REASON_TYPE_LABELS: Record<string, string> = {
  N: "Bez utjecaja na porez",
  U: "Utječe na porez",
  O: "Ostalo",
};
